import { useTrainingMedia } from '../../../hooks/useTrainingModules';
import { ModalShell } from '../../ui/ModalShell';

/**
 * Pick an image already used elsewhere in the training modules, so the same
 * picture (logo, hazard photo, sign) doesn't have to be re-uploaded per
 * module. The list is the distinct image URLs referenced across modules —
 * admin-authored content only, never inductee uploads.
 */
export function MediaLibraryModal({
  open,
  onClose,
  onPick,
}: {
  open: boolean;
  onClose: () => void;
  onPick: (url: string) => void;
}) {
  const media = useTrainingMedia(open);
  return (
    <ModalShell open={open} onClose={onClose} titleId="media-library" maxWidth="max-w-2xl">
      <div className="p-1">
        <h2 id="media-library" className="mb-3 text-base font-semibold text-fg">
          Choose an image
        </h2>
        {media.isLoading ? (
          <p className="py-8 text-center text-sm text-fg-muted">Loading…</p>
        ) : (media.data?.length ?? 0) === 0 ? (
          <p className="py-8 text-center text-sm text-fg-muted">
            No images yet. Upload one and it'll appear here for reuse.
          </p>
        ) : (
          <div className="grid max-h-[60vh] grid-cols-3 gap-2 overflow-y-auto sm:grid-cols-4">
            {media.data!.map((url) => (
              <button
                key={url}
                type="button"
                onClick={() => {
                  onPick(url);
                  onClose();
                }}
                className="overflow-hidden rounded-token-sm border border-line/10 hover:border-accent focus:outline-none focus:ring-2 focus:ring-accent/40"
              >
                <img src={url} alt="" className="h-24 w-full object-cover" />
              </button>
            ))}
          </div>
        )}
      </div>
    </ModalShell>
  );
}
